import React, {useState} from 'react';
import {Button, Drawer, Form, Menu, message, Modal, Spin} from "antd";
import NiceModal, {antdDrawer, antdModal, useModal} from "@ebay/nice-modal-react";
import {callWithCatch, pp} from "../utils";
import Device from "./Device";
import {useEffectOnce} from "react-use";
import {Switch2} from "./Switcher";

export const FormModalBtn = ({form, startShow, defer, onFinish, children, onOpen, savedMsg, formProps, vertical, onSave, asLink, asMenu, btnProps, okButtonProps, initialValues, text, reload, ...props}) => {
  if (!form)
    [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(startShow)

  let open = () => {
    onOpen && onOpen();

    setShow(true);
  }
  let close = () => setShow(false);

  let clickOk = () => form.submit();

  text = text || props.title;

  okButtonProps = okButtonProps || {};
  okButtonProps.loading = loading;

  formProps = formProps || {};
  formProps.initialValues = initialValues || formProps.initialValues || { }
  if (vertical)
    formProps.layout = "vertical";

  if (!onFinish)
  onFinish = async (vals) => {
    setLoading(true);

    try {
      await onSave(vals);
      if (savedMsg !== "none")
        message.success(savedMsg || "Saved!");

      if (reload)
        window.location.reload();
      else {
        form.resetFields();
        setLoading(false);
        close();
      }
    }
    catch(e) {
      message.error("Unknown error, not saved");
      setLoading(false);
      throw e;
    }
  }

  let btn;
  if (asLink)
    btn = <a onClick={open} {...btnProps}>{text}</a>
  else if (asMenu)
    btn = <Menu.Item key={text} onClick={open} {...btnProps}>{text}</Menu.Item>
  else
    btn = <Button onClick={open} {...btnProps}>{text}</Button>

  if (!show)
    return btn;

  return <div>
    {btn}
    { show && <Modal visible={show} onOk={clickOk} onCancel={close} okButtonProps={okButtonProps} okText="Save" {...props}>
      <Form form={form} onFinish={onFinish} {...formProps}>
        {children}
      </Form>
    </Modal> }
  </div>
};

export const LoaderDrawer = ({ params, children, ...props }) => {
  const [loading, setLoading] = useState(false);
  const modal = useModal();

  if (params)
    useEffectOnce(() => {
      callWithCatch({setLoading, ...params});
    });

  return <Drawer {...antdDrawer(modal)}
                 {...props}
  >
    <Switch2 v={!!loading}>
      <div className="p-2">
        <Spin />
      </div>
      {!loading && children}
    </Switch2>
  </Drawer>
};

export const SimpleNiceModal = ({modal, children, ...props}) => {
  if (!modal)
    modal = useModal();

  return <Modal
    {...antdModal(modal)}
    {...props}
  >
    {children}
  </Modal>
}

export const NiceModalForm = ({noLoading, disabled, topOnMobile, form, top, style, modal, okText, footer, okBtnInFooter, children, formProps, okButtonProps, initialValues, onSave, action, drawer, ...props}) => {
  if (!modal)
    modal = useModal();

  if (!form)
    [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  formProps = formProps || {};
  formProps.initialValues = initialValues || formProps.initialValues || { }
  formProps.layout = formProps.layout || "vertical";

  okButtonProps = okButtonProps || { disabled };
  okButtonProps.loading = loading;

  style = style || {};
  if (top || (topOnMobile && Device.xs))
    style.top = 20;

  let clickOk = () => form.submit();

  let onFinish = async (vals) => {
    setLoading(true);
    try {
      let close = await onSave(vals);

      if (close)
        modal.hide();
    }
    finally {
      setLoading(false);
    }
  }

  if (okBtnInFooter)
    footer = <Button onClick={() => form.submit()} block className="p-2" size="large" type="primary" {...okButtonProps}>{okText}</Button>;

  const formElement = (
    <Form form={form} onFinish={onFinish} {...formProps}>
      {children}
    </Form>
  );

  if (drawer) {
    if (!footer && footer !== false) {
      footer = (
        <div className="flex justify-between">
          <Button onClick={() => modal.hide()}>Cancel</Button>
          <Button type="primary" onClick={clickOk} {...okButtonProps}>{okText || "Save"}</Button>
        </div>
      );
    }
    
    return <Drawer
      {...antdDrawer(modal)}
      footer={footer}
      {...props}
    >
      {formElement}
    </Drawer>
  }

  return <Modal
    {...antdModal(modal)}
    footer={footer}
    okText={okText}
    okButtonProps={okButtonProps}
    onOk={clickOk}
    style={style}
    {...props}
  >
    {formElement}
  </Modal>
}

// need to set: title
export const ModalBtn = ({okButtonProps, onOpen, text, loading, asLink, onOk, onClose, children, btnProps={}, ...props}) => {
  const [show, setShow] = useState(false)

  let open = () => {
    onOpen && onOpen();
    setShow(true);
  }
  let close = () => {
    setShow(onClose ? onClose() : false);
  }

  let btn;
  if (asLink)
    btn = <a onClick={open} {...btnProps}>{text}</a>
  else
    btn = <Button loading={loading} onClick={open} {...btnProps}>{text}</Button>

  let clickOk = async () => {
    try {
      (await onOk()) && close();
    }
    catch (e) {
      throw(e);
    }
  };

  if (!show)
    return btn;

  return <div>
    {btn}
    <Modal visible={show} onOk={clickOk} onCancel={close} {...props} okButtonProps={okButtonProps}>
      {show && children}
    </Modal>
  </div>
}


